import type { FC } from "react"
import React, { useEffect, useRef, useState, useCallback } from "react"
import { useRequest, useMount } from "ahooks-v2"
import SliderTools from "./sliderTools"
import type { Captcha } from "@/api"
import { getCaptcha, verityCaptcha } from "@/api"
import { accMul, accDiv } from "@/util/util"
import "./index.scss"

type IVerity = {
  eid: string
  onSuccess?: (value: boolean) => void
}

const Verity: FC<IVerity> = ({ eid, onSuccess: success }) => {
  const sliderBg = useRef<HTMLDivElement>(null)
  const sliderImg = useRef<HTMLImageElement>(null)
  const sliderRef = useRef()
  const handleMoveendRef = useRef<() => void>()
  const [sliderImgLeft, setSliderImgLeft] = useState<number>(0)

  const { data: captcha = {} as Captcha, run: getCaptchaRun } = useRequest<Captcha>(getCaptcha, {
    manual: true,
  })

  useMount(() => {
    getCaptchaRun(eid)
  })

  const { eid: id = "", backImage = "", slidingImage = "", y = 0 } = captcha

  const { run } = useRequest(verityCaptcha, {
    manual: true,
    onSuccess: function (data) {
      if (!data) {
        getCaptchaRun(eid)
        setSliderImgLeft(0)
      }
      success && success(data)
    },
    refreshDeps: [eid],
  })

  const handleMove = useCallback(
    (ratio: number) => {
      const r =
        (sliderBg.current!.getBoundingClientRect().width -
          sliderImg.current!.getBoundingClientRect().width) *
        ratio
      setSliderImgLeft(r)
    },
    [setSliderImgLeft],
  )

  const handleMoveend = useCallback(() => {
    const r = accDiv(sliderImgLeft, sliderBg.current!.getBoundingClientRect().width)
    run(id, r)
  }, [id, sliderImgLeft, run])

  handleMoveendRef.current = handleMoveend

  useEffect(() => {
    if (sliderRef.current) {
      return
    }
    const slider: any = new SliderTools({
      el: document.querySelector(".verity-slider"),
    })

    sliderRef.current = slider

    slider.on("move", (ratio: number) => {
      handleMove(ratio)
    })

    slider.on("moveend", () => {
      handleMoveendRef.current!()
    })
  }, [handleMoveend, handleMove])

  return (
    <div className="verity flex flex-column flex-align-center">
      <div
        ref={sliderBg}
        className="slider-bg"
        style={{
          backgroundImage: `url(${backImage})`,
        }}
      >
        <img
          ref={sliderImg}
          className="slider-img"
          src={slidingImage}
          alt=""
          width="82"
          height="65"
          style={{ top: `${accMul(y, 100)}%`, left: `${sliderImgLeft}px` }}
        />
      </div>
      <div className="verity-slider" />
    </div>
  )
}

export default Verity
